var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProgressWaves',{staticClass:"mb-1",attrs:{"color":_vm.color,"width":_vm.moneySpent}}),_c('MyBudgetsPreviewDays',{attrs:{"color":_vm.color,"show-days":_vm.showDays,"days-passed":_vm.daysPassed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }